export default __webpack_public_path__ + "static/media/goshen58.3a36a451.JPG";